import '.g{display:grid;}.ssr-plugin'
import '.f{gap:1.5rem;}.ssr-plugin'
import '.gh{grid-template-columns:repeat(3, minmax(250px, 1fr));}.ssr-plugin'
import { useTranslations } from '@i18n/useLanguage'
import { SectionHeader } from '@app/components/blocks/sectionHeader/SectionHeader'
import { pages } from '@app/util/links'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import { styled } from 'inlines'
import { useQuery } from '@based/sdk/react'
import { useMemo } from 'react'
import { BlogSpotlightModel } from 'functions/app/spotlight/list'
import { useLocation } from 'wouter'
import Column from '@app/components/layout/Column'
import { BlogListModel } from 'functions/app/blog/list'

const COUNT = 3

type BlogItem = Omit<BlogListModel, 'author'>

export const BlogSection = () => {
  const [, navigate] = useLocation()
  const t = useTranslations().app
  const spotlightQuery = useQuery('list-spotlight', {
    entityType: 'blog',
    limit: COUNT,
  })
  const fallbackQuery = useQuery('list-blog', { top: COUNT })

  const blogPosts: BlogItem[] = useMemo(() => {
    const spotlights: BlogSpotlightModel[] = spotlightQuery.data ?? []
    const fallback: BlogItem[] = fallbackQuery.data ?? []
    const spotlighted = spotlights.map((s) => s.blog)

    if (spotlighted.length === COUNT) {
      return spotlighted
    }

    const nonDuplicated = fallback.filter(
      (fi) => spotlighted.findIndex((i) => i.id === fi.id) === -1,
    )

    return [...spotlighted, ...nonDuplicated].slice(0, COUNT)
  }, [spotlightQuery.data, fallbackQuery.data])

  if (blogPosts.length === 0) {
    return null
  }

  return (
    <Column alignItems="stretch">
      <SectionHeader
        title={t.landingPage.blogSection.title}
        subtitle={t.landingPage.blogSection.subTitle}
        seeMore={t.landingPage.blogSection.seeMore}
        toRoute={pages.blogs()}
      />
      <styled.div className="g f gh"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },
        }}
      >
        {blogPosts.map((post) => (
          <BlogCard
            key={post.id}
            image={post.images?.[0]?.src ?? ''}
            meta={
              post.category ??
              (post.publishedAt
                ? new Date(post.publishedAt).toLocaleDateString()
                : '')
            }
            title={post.title}
            intro={post.intro}
            orientation="vertical"
            onClick={() => navigate(pages.blog('blog', post.slug))}
          />
        ))}
      </styled.div>
    </Column>
  )
}
